import images from "@assets/images";
import { useNavigation } from "@react-navigation/native";
import { DimensionContext } from "@src/DimensionProvider";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedAvatarTier } from "@src/ducks/slices/lobby.slice";
import { selectedUserUserID } from "@src/ducks/slices/user.slice";
import { ImageButton } from "components/button";
import React from "react";
import { Image, Text, View } from "react-native";
import { useFetchGet } from "utils/api/hooks/useFetch";
import useStyles from "./styles.css";

const Details = () => {
  const styles = useStyles();
  const navigation = useNavigation<any>();
  const tier = useAppSelector(selectedAvatarTier);
  const userId = useAppSelector(selectedUserUserID);
  const { baseWidth } = React.useContext(DimensionContext);
  const { data } = useFetchGet(`/api/v1/leaderboard/score/${userId}`);

  return (
    <View style={styles.p_container}>
      <View style={styles.v_center_profile}>
        <Image
          style={styles.i_profile_frame}
          source={{uri: images.profile_frame}}
          resizeMode="stretch"
        />
        <View style={[styles.v_profile_divider, { height: baseWidth * 0.078}]} />
        <View style={styles.v_details}>
          <View
            style={[
              styles.v_player,
              { width: baseWidth * 0.1727, height: baseWidth * 0.043 },
            ]} >
            <Image
              style={styles.i_player_bg}
              source={{uri: images.bg_player}}
              resizeMode="stretch"
            />
            <ImageButton
              onPress={() => navigation.push("EditName")}
              style={styles.btn_edit}
              source={images.icon_edit}
            />
            <Text style={[styles.t_player_name, { fontSize: baseWidth * 0.015 }]} >
              {tier.displayName}
            </Text>
          </View>
          <View  style={[
            styles.i_yourrank,
            { width: baseWidth * 0.216, height: baseWidth * 0.09 },
          ]}>
            <Text style={[styles.t_rank, { fontSize: baseWidth * 0.02 }]}>
              YOUR
            </Text>
            <Image
              style={[
                { width: baseWidth * 0.1, height: baseWidth * 0.1 },
              ]}
              source={{uri: images.btn_rank}}
              resizeMode="stretch"
            />
            <Text style={[styles.t_rank, { fontSize: baseWidth * 0.02 }]}>
              RANK
            </Text>
          </View>
          
          <View
            style={[
              styles.v_ranking,
              { width: baseWidth * 0.1727, height: baseWidth * 0.043 },
            ]}
          >
            <Image
              style={styles.i_player_bg}
              source={{uri: images.bg_player}}
              resizeMode="stretch"
            />
            <Text style={[styles.t_rank, { fontSize: baseWidth * 0.02 }]}>
              {data?.rank ?? ""}
            </Text>
          </View>
          {/* <ImageButton06
            onPress={() => navigation.push("EditProfile")}
            style={[
              styles.btn_edit_profile,
              { width: baseWidth * 0.1827, height: baseWidth * 0.06, marginRight: baseWidth * 0.01 },
            ]}
            label="EDIT PROFILE"
            source={images["btn-big"]}
            labelStyle={{fontSize: baseWidth * 0.013}}
          /> */}
        </View>
      </View>
    </View>
  );
};

export default Details;
